import Button from "@/components/base/Button";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import type { Faq } from "@/types/content";

interface CareFaqProps {
  eyebrow: string;
  title: string;
  items: Faq[];
  idPrefix: string;
  tone?: "light" | "tinted";
}

/**
 * Accessible FAQ block for the specialist care pages — a heading column beside
 * an accordion, with a booking CTA for visitors who still have questions.
 */
export default function CareFaq({ eyebrow, title, items, idPrefix, tone = "tinted" }: CareFaqProps) {
  const background = tone === "tinted" ? "bg-background-100" : "bg-background-50";

  return (
    <section className={`${background} py-16 md:py-24`}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow={eyebrow}
              title={title}
              align="left"
              description="If your question is not answered here, our team is happy to help — just give us a call or request an appointment."
            />
            <div className="mt-7">
              <Button to="/appointment" size="md" icon="ri-calendar-check-line">
                Book an Appointment
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="reveal rounded-2xl border border-background-200 bg-background-50 px-6 py-2">
              <FaqAccordion items={items} idPrefix={idPrefix} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}